module.exports = __webpack_public_path__ + "img/客户案例-城图bg@2x.231c4690.png";